// import ObjArrUtils from '@/utils/ObjArrUtils'
import AppUtils from './AppUtils'

/** @module StoreUtils */

function warnNoCtx (ctx,caller) {
  if (!ctx)
    console.error(`No Vue instance context found. Please use \`this.${caller}\`(Global Mixin) instead of \`StoreUtils.${caller}\` in Vue component.`, `Caller: ${caller}`)
}

/**
 * Utilities for application
 * @property {Function} storeApiDispatch Utilities for dispatching store action
 *
 * @author Tin Ley Ter <leyter.tin@orbitmy.com>
 * @since 2022/07/20
 */
const StoreUtils = {
  /**
   * Utilities for dispatching store action
   *
   * @param {String} dispatchAction Store Action to be called on
   * @param {Object} data Data to be passed to action
   * @param {Object} options Options to be passed to action
   * - loading {Boolean}: [Default: `true`] Whether to show loading animation
   * - callback {Function}: [Default: Empty Function] Callback function
   * - errorDialog {Boolean}: [Default: `true`] Whether to show dialog when error happens
   * - errorTitle {String}: [Default: `common.messages.errorTitle`] Default error title
   * - errorMessage {String}: [Default: `common.messages.errorMessage`] Default error message
   * @param {Vue} ctx Vue instance
   * @returns {Promise} Store action returned promise
   */
  storeApiDispatch (dispatchAction, data = {}, options = {}, ctx = null) {
    warnNoCtx(ctx,'storeApiDispatch')
    return baseDispatch(
      function (mergedOptions) {
        const module = dispatchAction.split('/')[0]
        if (mergedOptions.clearError) ctx.$store.commit(module + '/REMOVE_ERRORS')
        return ctx.$store.dispatch(dispatchAction, data)
      }, options, ctx)
  }
}

/**
 *
 * @param {Function} callback
 * @param {Object} options
 * @param {Vue} ctx
 * @returns
 */
function baseDispatch (callback, options = {}, ctx) {
  const defaultOptions = {
    loading: true,
    clearError: true,
    callback: (res) => { },
    errorDialog: true,
    // throwOnError: false,
    // errorTitle: ctx.$t('common.messages.errorTitle'),
    // errorMessage: ctx.$t('common.messages.errorMessage'),
    errorTitle: '系统错误',
    errorMessage: '很抱歉，遇到了些许问题. 正在努力修复 , 请稍后再试',
    showDebugError: AppUtils.isDebugMode()
  }
  return callback(Object.assign(defaultOptions, options))
}
export default StoreUtils
